if (!customElements.get('swatch-dropdown')) {
  customElements.define(
    'swatch-dropdown',
    class CustomSelect extends HTMLElement {
      constructor() {
        super()

        this.init()
      }

      init() {
        this.trigger = this.querySelector('.js-swatch-dropdown-trigger')
        this.optionsContainer = this.querySelector('.js-swatch-dropdown-options')
        this.selectedOptionName = this.querySelector('.js-selected-option-name')
        this.selectedOptionSubtitle = this.querySelector('.js-selected-option-subtitle')
        this.selectedOptionSwatch = this.querySelector('.js-selected-option-swatch')
        this.options = Array.from(this.querySelectorAll('.js-swatch-dropdown-option'))
        this.productInfo = this.closest('.product-container')
        this.variantRadios = this.closest('variant-radios') || this.closest('quickbuy-variant-radios')
        // Remove existing listeners first to prevent duplicates
        this.removeEventListeners()
        this.addEventListeners()
      }

      addEventListeners() {
        this.trigger.addEventListener('click', () => this.toggleDropdown())
        document.addEventListener('click', (e) => this.handleClickOutside(e))
        this.options.forEach((option) => {
          option.addEventListener('click', (e) => this.handleOptionClick(e))
        })
        this.variantRadios.addEventListener('change', (e) => this.handleOptionChange(e))
      }

      removeEventListeners() {
        this.trigger.removeEventListener('click', () => this.toggleDropdown())
        document.removeEventListener('click', (e) => this.handleClickOutside(e))
        this.options.forEach((option) => {
          option.removeEventListener('click', (e) => this.handleOptionClick(e))
        })
        this.variantRadios.removeEventListener('change', (e) => this.handleOptionChange(e))
      }

      handleClickOutside(e) {
        if (!this.contains(e.target)) {
          this.closeDropdown()
        }
      }

      toggleDropdown() {
        const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true'
        if (isExpanded) {
          this.closeDropdown()
        } else {
          this.openDropdown()
        }
      }
      openDropdown() {
        this.trigger.setAttribute('aria-expanded', 'true')
        this.optionsContainer.hidden = false
        const caret = this.querySelector('.caret-down')
        if (caret) {
          caret.style.transition = 'all .3s'
          caret.style.transform = 'rotate(180deg)'
        }
      }

      closeDropdown() {
        this.trigger.setAttribute('aria-expanded', 'false')
        this.optionsContainer.hidden = true
        const caret = this.querySelector('.caret-down')
        if (caret) caret.style.transform = 'rotate(0deg)'
      }

      handleOptionClick(e) {
        // Prevent infinite loops from syncing
        if (this.dataset.syncing === 'true') {
          return
        }

        const value = e.currentTarget.dataset.value
        this.value = value
        // Update the trigger text
        if (!this.variantRadios) {
          this.variantRadios = this.closest('variant-radios, quickbuy-variant-radios')
        }

        let variantOption = this.variantRadios.querySelector(`[title*="${value}"]`)
        if (!variantOption) {
          const quickbuyVariantInput = this.variantRadios.querySelector(
            '.js-quickbuy-variant-single-input-for-swatch-dropdown'
          )

          if (quickbuyVariantInput) {
            quickbuyVariantInput.value = value
            quickbuyVariantInput.checked = true
            quickbuyVariantInput.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }

        if (variantOption) {
          variantOption.click()
        } else {
          console.error(`No variant option found for value: ${value}`)
        }
      }

      handleOptionChange(e) {
        // Prevent infinite loops from syncing
        if (e.target.closest('swatch-dropdown')?.dataset.syncing === 'true') {
          return
        }

        let option = e.target
        if (!e.target.classList.contains('js-swatch-dropdown-option')) {
          option = this.options.find((option) => option.dataset.value.toLowerCase() === e.target.value.toLowerCase())
        }

        if (!option) return
        console.log(this.dataset)
        this.value = option.dataset.value
        if (this.dataset.recommendedVariant === this.value && this.dataset.isBundle === 'true') {
          this.querySelector('[data-dropdown-initial]').classList.remove('hidden')
        } else if (this.querySelector('[data-dropdown-initial]')) {
          this.querySelector('[data-dropdown-initial]').classList.add('hidden')
        }
        // Update main button display
        this.selectedOptionName.innerHTML = option.querySelector('.js-option-name').innerHTML
        this.selectedOptionSubtitle.textContent = option.querySelector('.js-option-subtitle').textContent
        this.selectedOptionSwatch.style.backgroundColor =
          option.querySelector('.js-option-swatch').style.backgroundColor
        this.selectedOptionSwatch.style.backgroundImage =
          option.querySelector('.js-option-swatch').style.backgroundImage

        // Update option in list
        this.options.forEach(
          (option) => option.ariaSelected === 'true' && option.setAttribute('aria-selected', 'false')
        )
        option.setAttribute('aria-selected', 'true')

        this.closeDropdown()

        // Sync with sibling dropdowns (desktop/mobile)
        this.syncSiblingDropdowns(option.dataset.value)
      }

      syncSiblingDropdowns(value) {
        const productId = this.dataset.productId
        const optionPosition = this.dataset.optionPosition

        if (!productId || !optionPosition) return

        // Find all swatch-dropdowns for the same product and option
        const siblingDropdowns = document.querySelectorAll(
          `swatch-dropdown[data-product-id="${productId}"][data-option-position="${optionPosition}"]`
        )

        siblingDropdowns.forEach((dropdown) => {
          // Skip self
          if (dropdown === this) return

          // Mark as syncing to prevent infinite loops
          dropdown.dataset.syncing = 'true'

          // Find the option with matching value
          const targetOption = Array.from(dropdown.querySelectorAll('.js-swatch-dropdown-option')).find(
            (opt) => opt.dataset.value === value
          )

          if (targetOption) {
            // Update the visual state
            const selectedOptionName = dropdown.querySelector('.js-selected-option-name')
            const selectedOptionSubtitle = dropdown.querySelector('.js-selected-option-subtitle')
            const selectedOptionSwatch = dropdown.querySelector('.js-selected-option-swatch')

            if (selectedOptionName && targetOption.querySelector('.js-option-name')) {
              selectedOptionName.innerHTML = targetOption.querySelector('.js-option-name').innerHTML
            }
            if (selectedOptionSubtitle && targetOption.querySelector('.js-option-subtitle')) {
              selectedOptionSubtitle.textContent = targetOption.querySelector('.js-option-subtitle').textContent
            }
            if (selectedOptionSwatch && targetOption.querySelector('.js-option-swatch')) {
              selectedOptionSwatch.style.backgroundColor =
                targetOption.querySelector('.js-option-swatch').style.backgroundColor
              selectedOptionSwatch.style.backgroundImage =
                targetOption.querySelector('.js-option-swatch').style.backgroundImage
            }

            // Update aria-selected
            dropdown.querySelectorAll('.js-swatch-dropdown-option').forEach((opt) => {
              opt.setAttribute('aria-selected', opt === targetOption ? 'true' : 'false')
            })

            // Sync dropdown option badges
            const sourceOptionBadges = this.querySelectorAll('[data-dropdown-variant]')
            sourceOptionBadges.forEach((sourceBadge) => {
              const variantId = sourceBadge.dataset.dropdownVariant
              const targetBadge = dropdown.querySelector(`[data-dropdown-variant="${variantId}"]`)
              if (targetBadge && sourceBadge.innerHTML && !sourceBadge.classList.contains('hidden')) {
                targetBadge.classList.remove('hidden')
                targetBadge.innerHTML = sourceBadge.innerHTML
              }
            })

            dropdown.value = value
          }

          // Remove syncing flag after a short delay
          setTimeout(() => {
            delete dropdown.dataset.syncing
          }, 50)
        })
      }

      // Public method to programmatically set the value (useful for on-load automatic selections)
      updateValue(value) {
        const option = this.options.find((opt) => opt.dataset.value === value)
        if (option) {
          // Simulate an option change without triggering the variant selection again
          this.value = value

          // Update the visual state
          this.selectedOptionName.innerHTML = option.querySelector('.js-option-name').innerHTML
          this.selectedOptionSubtitle.textContent = option.querySelector('.js-option-subtitle').textContent
          this.selectedOptionSwatch.style.backgroundColor =
            option.querySelector('.js-option-swatch').style.backgroundColor
          this.selectedOptionSwatch.style.backgroundImage =
            option.querySelector('.js-option-swatch').style.backgroundImage

          // Update aria-selected
          this.options.forEach((opt) => {
            opt.setAttribute('aria-selected', opt === option ? 'true' : 'false')
          })

          // Sync siblings
          this.syncSiblingDropdowns(value)
        }
      }
    }
  )
}
